import '../../styles/notFound.css';

const NotFound = () => {
  return (
    <div id='not-found' className='flex'>
      404 | NotFound
    </div>
  );
};

export default NotFound;
